import React, { useState , useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {
  Box,
  Typography,
  Switch,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  Card,
  CardContent,
  Divider,
	TextField,
	Autocomplete,
	Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ButtonTheme from '../../../components/ThemeButton/ThemeButton';
import ApiService from '../../../functions/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Row , Col } from 'react-bootstrap';

const EntityModal = ({ entityModal, setEntityModal , data}) => {
	const [entityList , setEntityList] = useState([]);
	const [entity , setEntity] = useState('');
	const [entities , setEntities] = useState([]);
	const [addNewEntity , setAddNewEntity] = useState(false);
	const [entityNew , setEntityNew] = useState('');
	const [viewAttributeModal , setViewAttributeModal] = useState(false);
	const [addAttributeModal , setAddAttributeModal] = useState(false);
	const [addNewAttribute , setAddNewAttribute] = useState(false);
	const [attributesList , setAttributesList] = useState([]);
	const [attribute , setAttribute] = useState('');
	const [entityAllData , setEntityAllData] = useState([]);
	const [attributes , setAttributes] = useState([]);
	const [attributeNew , setAttributeNew] = useState('');
	const [attributeValue , setAttributeValue] = useState('');
	const [attributeNewValue , setAttributeNewValue] = useState(''); 
	const [deleteModal , setDeleteModal] = useState(false);
	const [deleteData , setDeleteData] = useState([]);

	const getEntities = () => {
		ApiService.post('/inventory/get-inventory-entity', {
			type: data?.type || 'item',
			...(data?.type
				? { location_id: data?.id }     
				: { item_location_id: data?.id }  
			)
		}).then((data) => {
			setEntities(data.data || [])
		}).catch((error) => {
			console.error(error);
		})
	}

	useEffect(()=>{
		getEntities()
	} , [])

	const entityDropdown = () => {
		ApiService.get("/inventory/get-active-entities")
			.then(({ data }) => {
				setEntityList(data?.data || [])
			})
			.catch((e) => {
				console.error(e.data.message)
			});
	};

	useEffect(()=>{
		entityDropdown()
	} , [])

	const handleEntity = () => {
		ApiService.post('/inventory/add-inventory-entity', {
			entity_id : entity,
			type: data?.type || 'item',
			...(data?.type
				? { location_id: data?.id }     
				: { item_location_id: data?.id }  
			)
		}).then((data) => {
			setEntity('')
			toast.success(data.message || 'Entity Created Successfully')
			getEntities()
		}).catch((error) => {
			console.error(error);
			toast.error(error?.data?.message || 'error')
		})
	}

	const handleNewEntity = () => {
		ApiService.post('/inventory/add-new-inventory-entity', {
			entity_name : entityNew,
			type: data?.type || 'item',
			...(data?.type
				? { location_id: data?.id }     
				: { item_location_id: data?.id }  
			)
		}).then((data) => {
			setEntityNew('')
			toast.success(data.message || 'Entity Created Successfully')
			getEntities()
		}).catch((error) => {
			console.error(error);
			toast.error(error?.data?.message || 'error')
		})
	}

	const getAttributes = (entitiesData) => {
		ApiService.post('/inventory/inventory-entity-attribute', {
			type: data?.type || 'item',
			...(data?.type
				? { loc_entity_id : entitiesData?.id }     
				: { item_entity_id : entitiesData?.id }  
			)
		}).then((data) => {
			setAttributes(data.data || [])
		}).catch((error) => {
			console.error(error);
		})
	}

	const attributeDropdown = () => {
		ApiService.get("/inventory/get-active-attributes")
			.then(({ data }) => {
				setAttributesList(data?.data || [])
			})
			.catch((e) => {
				console.error(e.data.message)
			});
	};

	const handleAttribute = (item) => {
		ApiService.post('/inventory/add-inventory-entity-attribute', {
			attribute_id : attribute,
			type: data?.type || 'item',
			...(data?.type
				? { loc_entity_id : item?.id }     
				: { item_entity_id : item?.id }  
			),
			value : attributeValue,
		}).then((data) => {
			setAddNewAttribute(false);
			setAddAttributeModal(false);
			setAttribute('')
			setAttributeValue('')
			toast.success(data.message || 'Attribute Created Successfully')
			getAttributes()
		}).catch((error) => {
			console.error(error);
			toast.error(error?.data?.message || 'error')
		})
	}

	const handleNewAttribue = (item) => {
		ApiService.post('/inventory/add-new-inventory-entity-attribute', {
			attribute_name : attributeNew,
			type: data?.type || 'item',
			...(data?.type
				? { loc_entity_id : item?.id }     
				: { item_entity_id : item?.id }  
			),
			value : attributeNewValue
		}).then((data) => {
			setAddNewAttribute(false);
			setAddAttributeModal(false);
			setAttributeNew('')
			setAttributeNewValue('')
			toast.success(data.message || 'Attribute Created Successfully')
			getAttributes()
		}).catch((error) => {
			console.error(error);
			toast.error(error?.data?.message || 'error')
		})
	}

	const entityLocationDelete = (deleteData) => {
		ApiService.get(`/inventory/delete-location-entity/${deleteData.id}`)
			.then(({ data }) => {
				setDeleteModal(false);
				toast.success(data.message || 'Location Entity deleted Successfully')
				getEntities();
			})
			.catch((e) => {
				console.error(e.data.message)
				toast.error(e?.data?.message || 'error')
			});
	};

	const entityItemDelete = (deleteData) => {
		ApiService.get(`/inventory/delete-item-entity/${deleteData.id}`)
			.then(({ data }) => {
				setDeleteModal(false);
				toast.success(data.message || 'Item Entity deleted Successfully');
				getEntities();
			})
			.catch((e) => {
				console.error(e.data.message)
				toast.error(e?.data?.message || 'error')
			});
	};

	const attributeLocationDelete = (deleteData) => {
		ApiService.get(`/inventory/delete-location-entity-attribute/${deleteData.id}`)
			.then(({ data }) => {
				toast.success(data.message || 'Location Attribute deleted Successfully')
				setViewAttributeModal(false)
			})
			.catch((e) => {
				console.error(e.data.message)
				toast.error(e?.data?.message || 'error')
			});
	};

	const attributeItemDelete = (deleteData) => {
		ApiService.get(`/inventory/delete-item-entity-attribute/${deleteData.id}`)
			.then(({ data }) => {
				toast.success(data.message || 'Item Attribute deleted Successfully');
				setViewAttributeModal(false)
			})
			.catch((e) => {
				console.error(e.data.message)
				toast.error(e?.data?.message || 'error')
			});
	};


  return (
		<>
			<Modal show={entityModal} onHide={() => setEntityModal(false)} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Entities</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Box className="p-2">
						<Box
							className="mb-3 px-3 py-2"
							sx={{
								display: 'flex',
								alignItems: 'center',
								border: '1px solid #cccccc',
								width: 'fit-content',
								gap: 1,
								boxShadow:'0px 0px 20px 0px rgba(0, 0 , 0 , 0.1)'
							}}
						>
							{data?.type == 'location' ? 
								<img src="/images/location-blue-new.svg" alt="location" style={{ height: 20, width: 20 }} />
								:
								data?.type == 'location_item' ? 
								<img src="/images/location-item.svg" alt="location" style={{ height: 20, width: 20 }} />
								:
								<img src="/images/location-blue.svg" alt="location" style={{ height: 20, width: 20 }} />
							}
							<Typography variant="subtitle1">{data?.location_description || data?.item?.item_description}</Typography>
						</Box>

						{entities && entities?.length > 0 ?
							<Card variant="outlined" className='mb-4' sx={{borderRadius:'8px' , maxHeight:'40vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
								<CardContent sx={{padding:'0px' , '&:last-child': {
										paddingBottom: 0,
									},}}>
									{entities.map((item, index) => (
										<Box
											key={index}
											sx={{
												justifyContent: 'space-between',
											}}
										>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , padding:'8px'}}>
												<img src="/images/entity-shade.svg" alt={item?.name} style={{ width: 20, height: 20 , marginLeft:'10px' }} />
												<Typography sx={{ fontWeight: 600 , minWidth:'200px' }}>{item?.entity?.name || ''}</Typography>
												<Typography variant="body2" sx={{minWidth:'120px' , fontSize:'14px'}}>
													{moment(item.created_at).format('MM/DD/YYYY')}
												</Typography>
												<div style={{display:'flex' , gap:1}}>
													<Button size="sm" 
														style={{
															minWidth:'100px' , 
															marginLeft:'10px' , 
															borderRadius:'20px' , 
															border:'1px solid #2B3F6C' , 
															backgroundColor:'#EAECF0',
															color:'#2B3F6C'
														}}
														onClick={() => {
															setAddAttributeModal(true)
															attributeDropdown()
															setEntityAllData(item)
														}}
													> +  Attributes</Button>
													<Button size="sm" 
														style={{
															minWidth:'140px' , 
															marginLeft:'10px' , 
															borderRadius:'20px' ,
															border:'1px solid #2B3F6C' , 
															backgroundColor:'#EAECF0',
															color:'#2B3F6C'
														}}
														onClick={() => {
															setViewAttributeModal(true)
															getAttributes(item)
														}}
														>
															<img src='/images/blue-eye.svg' style={{marginRight:'4px'}}/>
															Attributes ({item?.attributes_count})</Button>
												</div>
												<IconButton>
													<DeleteIcon 
														onClick={()=> {
															setDeleteModal(true)
															setDeleteData(item)
														}}
													/>
												</IconButton>
											</Box>

											{index < entities.length - 1 && <Divider sx={{ width: '100%' , backgroundColor:'#cccccc' }} />}
										</Box>
									))}
								</CardContent>
							</Card>
							: 
							<div className='d-flex flex-column align-items-center justify-content-center mb-3'>
								<img src='/images/blur-logo.png' style={{ height: 120, width: 150 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No any entities
								</span>
							</div>
						}

						<Box>
							<div style={{display:'flex' , justifyContent:'space-between' , marginBottom:'8px'}}>
								<div>
									{addNewEntity ?
										<Typography variant="h6">
											Add New Entity
										</Typography>
										:
										<Typography variant="h6">
											Add More Entity
										</Typography>
									}
								</div>

								<div>
									{
										addNewEntity ? (
											<p
												style={{ color: '#BF1D2D', cursor: 'pointer' , textDecoration:'underline' , fontSize:'14px' }}
												onClick={() => {
													setAddNewEntity(false)
													setEntityNew('')
												}}
											>
												←  Add from dropdown 
											</p>
										) : (
											<p
												style={{ color: '#BF1D2D', cursor: 'pointer' , textDecoration:'underline' , fontSize:'14px' }}
												onClick={() => {
													setAddNewEntity(true)
													setEntity('')
												}}
											>
												+ Add new entity
											</p>
										)
									}
								</div>
							</div>

							{addNewEntity ? 
								<TextField
									variant="outlined"
									placeholder="Entity name"
									value={entityNew}
									onChange={(e) => setEntityNew(e.target.value)}
									className="w-100"
									InputProps={{
										sx: {
											height: '48px',
											fontSize: '14px',
											marginRight: '10px',
										},
									}}
								/>
								:
								<Autocomplete
									size="small"
									options={entityList}
									getOptionLabel={(option) => option.name || ""}
									onChange={(event, newValue) => setEntity(newValue ? newValue.id : "")}
									sx={{
										width: '100%',
										'& .MuiInputBase-root': {
											height: '48px',
											fontSize: '14px',
										},
										'& .MuiInputLabel-root': {
											marginTop: '4px',
											fontSize: '14px',
										}
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Entity"
											placeholder="All"
											variant="outlined"
											color="secondary"
										/>
									)}
								/>
							}

							<Box sx={{ display: 'flex', gap: 2 }}>
								<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4 px-4' 
									disabled={addNewEntity ? !entityNew : !entity}
									onClick={()=>{
										if(addNewEntity){
											handleNewEntity()
										}
										else{
											handleEntity()
										}
									}}
								>
									Add
								</ButtonTheme>
							</Box>
						</Box>
					</Box>
				</Modal.Body>
			</Modal>

			<>
				<style>{`
					.custom-modal-lg {
						padding: 0px 100px;
					}
				`}</style>

				<Modal 
					show={viewAttributeModal} 
					onHide={() => setViewAttributeModal(false)}
					size="lg"
					dialogClassName="custom-modal-lg"
				>
					<div
						style={{
							boxShadow: '0px 10px 60px rgba(0, 0, 0, 0.4)',
							borderRadius: '6px',
						}}
					>
						<Modal.Header closeButton>
							<Modal.Title>View Attributes</Modal.Title>
						</Modal.Header>
							<Modal.Body>
								{attributes && attributes?.length > 0 ?
									<Card variant="outlined" className='mb-2' sx={{borderRadius:'8px' , maxHeight:'70vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
										<CardContent sx={{padding:'0px' , '&:last-child': {
												paddingBottom: 0,
											},}}>
											{attributes.map((item, index) => (
												<Box
													key={index}
													sx={{
														justifyContent: 'space-between',
													}}
												>
													<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , padding:'8px'}}>
														<img src="/images/entity-shade.svg" alt={item?.name} style={{ width: 20, height: 20 , marginLeft:'10px' }} />
														<Typography sx={{ fontWeight: 600 , minWidth:'190px' }}>{item?.attribute?.name || ''}</Typography>
														<Typography variant="body2" sx={{minWidth:'120px' , fontSize:'14px'}}>
															{moment(item.created_at).format('MM/DD/YYYY')}
														</Typography>
														<Chip label={item?.value || ''} sx={{padding:'6px 20px' , backgroundColor:'#BF1D2D' , color:'#ffffff'}}/>
														<IconButton>
															<DeleteIcon 
																onClick={()=> {
																	if(data.type){
																		attributeLocationDelete(item)
																	}else{
																		attributeItemDelete(item)
																	}
																}}
															/>
														</IconButton>
													</Box>

													{index < attributes.length - 1 && <Divider sx={{ width: '100%' , backgroundColor:'#cccccc' }} />}
												</Box>
											))}
										</CardContent>
									</Card>
									: 
									<div className='d-flex flex-column align-items-center justify-content-center mb-3'>
										<img src='/images/blur-logo.png' style={{ height: 120, width: 150 }} />
										<span className='mt-4' style={{ color: '#555555' }}>
											No any attributes
										</span>
									</div>
								}
							</Modal.Body>
					</div>
				</Modal>
			</>

			<Modal show={addAttributeModal} 
				onHide={() => { 
					setAddAttributeModal(false)
					setAddNewAttribute(false)
					setAttributeNew('')
					setAttribute('')
					setAttributeValue('')
				}} size="md" >
				<div
					style={{
						boxShadow: '0px 10px 60px rgba(0, 0, 0, 0.4)',
						borderRadius: '6px'
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>Add Attributes</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div style={{width:'34%'}}>
							{
								addNewAttribute ? (
									<p
										style={{ color: '#BF1D2D', cursor: 'pointer' , textDecoration:'underline' , fontSize:'14px' }}
										onClick={() => {
											setAddNewAttribute(false)
											setAttributeNewValue('')
											setAttributeNew('')
										}}
									>
										← Add from dropdown 
									</p>
								) : (
									<p
										style={{ color: '#BF1D2D', cursor: 'pointer' , textDecoration:'underline' , fontSize:'14px'}}
										onClick={() => {
											setAddNewAttribute(true)
											setAttribute('')
											setAttributeValue('')
										}}
									>
										+ Add new attribute
									</p>
								)
							}
						</div>

						<Box>
							{addNewAttribute ? 
								<>
									<TextField
										variant="outlined"
										placeholder="Attribute name"
										value={attributeNew}
										onChange={(e) => setAttributeNew(e.target.value)}
										className="w-100"
										InputProps={{
											sx: {
												height: '48px',
												fontSize: '14px',
												marginRight: '10px',
											},
										}}
									/>
									<TextField
										variant="outlined"
										placeholder="Attribute value"
										value={attributeNewValue}
										onChange={(e) => setAttributeNewValue(e.target.value)}
										className="w-100 mt-2"
										InputProps={{
											sx: {
												height: '48px',
												fontSize: '14px',
												marginRight: '10px',
											},
										}}
									/>
								</>
								:
								<>
									<Autocomplete
										size="small"
										options={attributesList}
										getOptionLabel={(option) => option.name || ""}
										onChange={(event, newValue) => setAttribute(newValue ? newValue.id : "")}
										sx={{
											width: '98%',
											'& .MuiInputBase-root': {
												height: '48px',
												fontSize: '14px',
											},
											'& .MuiInputLabel-root': {
												marginTop: '4px',
												fontSize: '14px',
											}
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Attributes"
												placeholder="Select Attribute"
												variant="outlined"
												color="secondary"
											/>
										)}
									/>
									<TextField
										variant="outlined"
										placeholder="Attribute value"
										value={attributeValue}
										onChange={(e) => setAttributeValue(e.target.value)}
										className="w-100 mt-2"
										InputProps={{
											sx: {
												height: '48px',
												fontSize: '14px',
												marginRight: '10px',
											},
										}}
									/>
								</>
							}
						</Box>
				
						<Box sx={{ display: 'flex', gap: 2 }}>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4 px-4' 
								disabled={addNewAttribute ? !attributeNew || !attributeNewValue : !attribute || !attributeValue}
								onClick={()=>{
									if(addNewAttribute){
										handleNewAttribue(entityAllData)
									}
									else{
										handleAttribute(entityAllData)
									}
								}}
							>
								Add
							</ButtonTheme>
						</Box>
					</Modal.Body>
				</div>
			</Modal>

			<Modal show={deleteModal} 
				onHide={() => { 
					setDeleteModal(false)
				}} size="md" >
				<div
					style={{
						boxShadow: '0px 10px 60px rgba(0, 0, 0, 0.4)',
						borderRadius: '6px'
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>Delete Entity</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div style={{ color: '#555555' }}>
							Are you sure to delete?
						</div>
						<Row>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
									Cancel
								</ButtonTheme>
							</Col>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' 
									onClick={ () => {
										if(data?.type){
											entityLocationDelete(deleteData)
										}else{
											entityItemDelete(deleteData)
										}
									}}
								>
									Delete
								</ButtonTheme>
							</Col>
						</Row>
					</Modal.Body>
				</div>
			</Modal>
		</>
  );
};

export default EntityModal;
